import React, { useState, useEffect } from 'react';
import apiClient from '../services/apiClient';

// Lets a franchise location opt in/out of showing an admin-created offer at their store.
const FranchiseOffersOptIn = ({ franchiseId }) => {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [togglingId, setTogglingId] = useState(null);

    useEffect(() => {
        fetchOffers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [franchiseId]);

    const fetchOffers = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const response = await apiClient.get('/offers/franchise-list', {
                params: franchiseId ? { franchiseId } : {},
                headers: { Authorization: `Bearer ${token}` }
            });
            setOffers(response.data.offers || []);
        } catch (error) {
            console.error('Failed to fetch offers:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleToggle = async (offer) => {
        setTogglingId(offer._id);
        try {
            const token = localStorage.getItem('token');
            await apiClient.put(`/offers/${offer._id}/toggle-franchise`, { franchiseId }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchOffers();
        } catch (error) {
            alert(error.response?.data?.message || 'Failed to update offer.');
        } finally {
            setTogglingId(null);
        }
    };

    if (loading) return <div className="p-8 text-center bg-white rounded-lg shadow">Loading offers...</div>;

    return (
        <div className="space-y-4">
            {offers.length === 0 ? (
                <div className="bg-white p-12 text-center rounded-xl border-2 border-dashed border-gray-200">
                    <h3 className="text-lg font-bold text-gray-600">No active offers right now</h3>
                    <p className="text-gray-400 text-sm">When admin creates a flash offer, it will show up here for you to enable.</p>
                </div>
            ) : (
                <div className="grid gap-3">
                    {offers.map(offer => (
                        <div key={offer._id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex items-center justify-between gap-4">
                            <div className="flex items-center gap-3 min-w-0">
                                {offer.product?.images?.[0] && (
                                    <img src={offer.product.images[0]} alt={offer.product?.name} className="w-12 h-12 rounded object-cover flex-shrink-0" />
                                )}
                                <div className="min-w-0">
                                    <p className="text-sm font-bold text-gray-900 truncate">{offer.product?.name}</p>
                                    <p className="text-xs text-gray-500">{offer.title} {offer.size ? `· Pack: ${offer.size}` : ''}</p>
                                    <p className="text-sm font-bold text-green-600">₹{offer.offerPrice}</p>
                                </div>
                            </div>
                            <button
                                onClick={() => handleToggle(offer)}
                                disabled={togglingId === offer._id}
                                className={`px-4 py-2 rounded-lg text-sm font-semibold flex-shrink-0 transition-colors ${
                                    offer.isEnabledForMyFranchise
                                        ? 'bg-green-600 text-white hover:bg-green-700'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
                                }`}
                            >
                                {offer.isEnabledForMyFranchise ? 'Showing at my store' : 'Show at my store'}
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default FranchiseOffersOptIn;
